export function findUniqueValues<T>(arr: T[]): T[] {
  return Array.from(new Set(arr));
}

export function findUniqueValuesByKey<T>(arr: T[], key: keyof T): T[] {
  const mapByKey = new Map();
  arr.forEach((value) => {
    const id = value[key];
    if (!mapByKey.has(id)) {
      mapByKey.set(id, value);
    }
  });

  return Array.from(mapByKey.values());
}
